import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ActivatedRoute } from '@angular/router';
import { concatMap, filter, takeWhile } from 'rxjs';

import { City, Country,State } from 'src/app/models/master-data.model';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';

@Component({
  selector: 'app-website-filters',
  templateUrl: './website-filters.component.html',
  styleUrls: ['./website-filters.component.scss']
})
export class WebsiteFiltersComponent {
  @Input() data: any[] = [];
  @Output() filteredData = new EventEmitter<any>();
  @Output() filterObjectEmitter = new EventEmitter<any>();
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;
  @ViewChild('searchContainer') searchContainer: ElementRef | undefined;
  paramsSearch: any;
  debounceTimer: any;
  dataObj: any[] = [];
  filteredObj: any[] = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  showNoRecordsFounds: boolean = true;
  filterObject: any;
  countries!: any[];
  allCountriesSymbol: any[] = [];
  states!: any[];
  cities!: any[];
  distributorId!: any[];
  categoryId!: any[];
  yearInMarkets!: any[];
  keywords: string[] = [];
  filteredCurrencySymbols: any[] = [];
  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  distributorControl = new FormControl();
  categoryControl = new FormControl();
  currencySymbolControl = new FormControl();
  amountRangeControl = new FormControl();
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  filteredDistributors: any[] | undefined;
  filteredCategories: any[] | undefined;
  searchSuggestions: any[] = [];
  isSugestionOpen: boolean = false;
  filterForm: FormGroup = new FormGroup({
    keywords: new FormControl([]),
    continents: new FormControl([]),
    countries: new FormControl([]),
    states: new FormControl([]),
    cities: new FormControl([]),
    postalCode: new FormControl(null),
    distributorId: new FormControl([]),
    yearFrom: new FormControl(0),
    yearTo: new FormControl(0),
    categoryId: new FormControl([]),
    currency: new FormControl(null),
    turnOver: new FormControl([]),
  });

  currencySymbol: string = '';
  filterControls = ['keywords','countries', 'states', 'cities', 'postalCode', 'distributorId', 'yearFrom', 'yearTo', 'categoryId','currency', 'turnOver'];
  textFromUniversalSearch: any = ''

    constructor(
      private readonly masterDataService: MasterDataService,
      private distributorService: DistributorService,
      private categoryService: CategoryService,
      private renderer: Renderer2,
      private sharedService: SharedService,
      private activatedRoute: ActivatedRoute
    ) {
      window.addEventListener('scroll', this.scrollEvent, true);
    }

    amountRange: { label: string; min: number; max: number }[] = [
      { label: '0 - 50K', min: 0, max: 50000 },
      { label: '50K - 100K', min: 50001, max: 100000 },
      { label: '100K - 150K', min: 100001, max: 150000 },
      { label: '150K - Other', min: 150001, max: Infinity },
    ];
    scrollEvent = (event: any): void => {
      const target = event.target as HTMLElement;
      const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
        if (autoComplete.panelOpen) {
          const panel = autoComplete.autocomplete.panel;
          return panel && panel.nativeElement.contains(target);
        }
        return false;
      });
    if (!isScrollingInsidePanel) {
        this.closeAllPanels();
    }
  };
    closeAllPanels() {
      this.autoCompletes.forEach(autoComplete => {
        if (autoComplete.panelOpen) {
          autoComplete.closePanel();
        }
      });
    }
    ngOnChanges(changes: SimpleChanges): void {
      this.dataObj = this.data;
    }
    ngOnInit(): void {
      this.filterForm.valueChanges.subscribe(() => {
         this.buildFilterObject();
        this.updateFilterObjectAndFetch();
      });
      this.loadDistributors('');
      this.loadCountries('');
      this.loadcategories();
      this.activatedRoute.queryParamMap.subscribe(params => {
        this.paramsSearch = params.get('search') || '';
        this.textFromUniversalSearch = this.paramsSearch ;
        this.searchSuggestion(this.paramsSearch)
        this.paramsSearch ='';
      })
      this.countryControl.valueChanges.subscribe(value => {
        if (!value?.countryName) {
          this.filteredCountries = this.countries.filter(country =>
            country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
          );
        }
      });
      this.stateControl.valueChanges.subscribe(value => {
        if (!value?.stateName) {
          this.filteredStates = this.states.filter(state =>
            state.stateName.toLowerCase().includes(value?.toLowerCase() || '')
          );
        }
      });
      this.cityControl.valueChanges.subscribe(value => {
        if (!value?.cityName) {
          this.filteredCities = this.cities.filter(city =>
            city.cityName.toLowerCase().includes(value?.toLowerCase() || '')
          );
        }
      });
      this.distributorControl.valueChanges.subscribe(value => {
        this.loadDistributors(value || '');
      });
      this.categoryControl.valueChanges.subscribe(value => {
        if (!value?.name) {
          this.filteredCategories = this.categoryId.filter(categoryId =>
            categoryId.name.toLowerCase().includes(value?.toLowerCase() || '')
          );
        }
      });
  
      this.renderer.listen('document', 'click', (event: Event) => {
        const searchElement = this.searchContainer?.nativeElement;
        if (searchElement && !searchElement.contains(event.target)) {
          this.isSugestionOpen = false;
        }
      });
    this.currencySymbolControl.valueChanges.subscribe(value => {
      if (typeof value === 'string' && value) {
        this.filteredCurrencySymbols = this.allCountriesSymbol.filter(symbol =>
          symbol.label.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.filteredCurrencySymbols = this.allCountriesSymbol;
      }
    });
  }
buildFilterObject(): void {
  const formValue = this.filterForm.value;
  this.filterObject = {
    country: formValue.country || null,
    currencySymbol: formValue.currencySymbol || null,
    category: formValue.category || null,
    minValue: formValue.valueRange?.min || null,
    maxValue: formValue.valueRange?.max || null,
    keywords: formValue.keywords || null
  
  };
}
    toggleSuggestions() {
      this.isSugestionOpen = !this.isSugestionOpen;
    }
  keyword:any ='';
  updateFilterObjectAndFetch(): void {
  const formValues = this.filterForm.value;
  this.filterObject = {};
  if (formValues.countries) {
    this.filterObject.countries = formValues.countries;
  }
  if(formValues.distributorId){
    this.filterObject.distributorId = formValues.distributorId.map((distributor: any) => distributor.id);
  }
  if (formValues.states) {
    this.filterObject.states = formValues.states;
  }
  if (formValues.cities) {
    this.filterObject.cities = formValues.cities;
  }
  if (formValues.keywords) {
 
    // this.filterObject.keywords = Array.isArray(formValues.keywords) ? formValues.keywords : [formValues.keywords];
    this.filterObject.keywords = formValues.keywords;
  }
  if (formValues.yearFrom) {
    this.filterObject.yearFrom = formValues.yearFrom;
  }

  if (formValues.yearTo) {
    this.filterObject.yearTo = formValues.yearTo;
  }

  if (formValues.categoryId) {
    this.filterObject.categoryId = formValues.categoryId.map((category: any) => category.id);
  }

  if (formValues.currencySymbol) {
    this.filterObject.currencySymbol = formValues.currencySymbol;
  }

  if (formValues.valueRange?.min != null) {
    this.filterObject.minValue = formValues.valueRange.min;
  }

  if (formValues.valueRange?.max != null) {
    this.filterObject.maxValue = formValues.valueRange.max;
  }

  this.distributorService.getDistributorsList(this.filterObject, this.keyword, 0, 9).subscribe({
      next: (res) => {
        const filtered = res || [];
        this.filteredData.emit(filtered); 
        this.filterObjectEmitter.emit(this.filterObject);
      },
      error: (err) => {
        console.error('Failed to fetch distributors', err);
      }
    });
}
  applyFilter(): void {
    this.updateFilterObjectAndFetch();
  }
  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;
    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe({next: (data) => {
          allCountries = allCountries.concat(data.data);
          this.countries = allCountries;
          this.filteredCountries = allCountries;
          this.allCountriesSymbol = Array.from(
            new Map(
              allCountries
                .filter(country => country.currency && country.currencySymbol)
                .map(country => [
                  country.currency,
                  {
                    currency: country.currency,
                    currencySymbol: country.currencySymbol,
                    countryName: country.countryName,
                    label: `${country.currencySymbol} - ${country.currency}`
                  }
                ])
            ).values()
          );
          this.filteredCurrencySymbols = this.allCountriesSymbol;
          if (this.allCountriesSymbol.length === 0) {
            console.warn('No currencies found in country data. Check API response.');
          }
        },
        error: (error) => {
          console.error('Error loading countries:', error);
          this.allCountriesSymbol = [];
          this.filteredCurrencySymbols = [];
        }
      });
  }

  loadStates() {
    if(!this.filterForm.get('countries')?.value?.length) {
      this.states = [];
      this.filteredStates = [];
      return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allStates: any[] = [];
    let morePages = true;
    this.masterDataService.getStates(pageNumber, pageSize, '', this.filterForm.get('countries')?.value)
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', this.filterForm.get('countries')?.value);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }

  loadCities() {
    if(!this.filterForm.get('states')?.value?.length) {
      return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allCities: any[] = [];
    let morePages = true;
    this.masterDataService.getCities(pageNumber, pageSize, '', this.filterForm.get('states')?.value)
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', this.filterForm.get('states')?.value);
        })
      )
      .subscribe(data => {
        if (data.data) {
          allCities = allCities.concat(data.data);
        }
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }
  loadDistributors(suggestion: string | { name: string }) {
    let suggestionString: string;
    if (typeof suggestion === 'string') {
      suggestionString = suggestion;
    } else {
      suggestionString = suggestion.name;
    }
    this.distributorService.searchSuggestionForDistributor(suggestionString).subscribe({
      next: (response) => {
        this.distributorId = response.data.sort((a: any, b: any) => {
          const nameA = a.name.replace(/^ /, '').toLowerCase();
          const nameB = b.name.replace(/^ /, '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.filteredDistributors = this.distributorId;
        this.yearInMarkets = [...new Set(
         this.distributorId
          .map((item: { year: any }) => item.year)
          .filter((year: any) => year != null && year !== '' && year !== 0)
        )];
      },
      error: (error) => {}
    });
  }

  loadcategories() {
    this.categoryService.getLastNodeCategory().subscribe(data => {
      if (data && data.data && data.data.length > 0) {
        this.categoryId = data.data;
        if (!this.filteredCategories) {
          this.filteredCategories = data.data;
        }
      }
    }, error => {});
  }
  resetFilters() {
    const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.keywords = [];
    this.filterForm?.reset();
    this.currencySymbolControl.reset();
    this.amountRangeControl.reset();
  }

  add(event: any, isSuggestion: boolean = false): void {
    const value = (event.value || '').trim();
    if (value && !this.keywords.includes(value)) {
      this.keywords = [...this.keywords, value];
    if (isSuggestion) {
      this.searchSuggestions = [];
        this.isSugestionOpen = false;
      }
      const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = '';
      }
      // this.applyFilter(); 
    }
  }

  searchSuggestionDebouncer(event: any) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() =>
      this.searchSuggestion(event), 450);
  }

  searchSuggestion(event: any): void {
    const query = this.paramsSearch || event?.target?.value?.trim() || '';
    if (query) {
      this.distributorService.searchSuggestionForDistributor(query).subscribe({
        next: (response) => {
          this.searchSuggestions = response.data || [];
          this.isSugestionOpen = this.searchSuggestions.length > 0;
        },
        error: (error) => {
          this.searchSuggestions = [];
          this.isSugestionOpen = false;
        }
      });
    } else {
      this.searchSuggestions = [];
      this.isSugestionOpen = false;
  }
  }

  selectedSuggestion(suggestion: any): void {
    if (suggestion?.name) {
      const currentKeywords = this.filterForm.get('keywords')?.value || [];
      this.filterForm.get('keywords')?.setValue([...currentKeywords, suggestion.name]);
    }
    this.searchSuggestions = [];
      const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = '';
    }
  }
  removeKeyword(keyword: string): void {
    const index = this.keywords.indexOf(keyword);
    if (index >= 0) {
      this.keywords.splice(index, 1);
      this.applyFilter();
    }
  }

  remove(controlName: string, item: any): void {
    const control = this.filterForm.get(controlName);
    if (control) {
      let currentValues = control.value || [];
      let index = -1;
      if (controlName === 'distributorId' || controlName === 'categoryId') {
        index = currentValues.findIndex((val: any) => val.id === item.id);
      } else if (controlName === 'currency') {
        index = currentValues.findIndex((val: any) => val.currency === item.currency);
      } else if (controlName === 'turnOver') {
        index = currentValues.findIndex((val: any) => val.label === item.label);
      } else {
        index = currentValues.indexOf(item);
      }

      if (index >= 0) {
        currentValues.splice(index, 1);
        control.setValue(currentValues);
      }
      if (currentValues.length === 0) {
        control.reset();
      }
      this.applyFilter();
      if (controlName === 'distributorId') {
        this.distributorControl.reset();
      } else if (controlName === 'currency') {
        this.currencySymbolControl.reset();
      } else if (controlName === 'turnOver') {
        this.amountRangeControl.reset();
      }
    }
  }
  onOptionSelected(event: any, filterType: string): void {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'country':
        const selectedCountryName = event.option.value.countryName;
        currentValues = this.filterForm.get('countries')?.value || [];
        if (!currentValues.includes(selectedCountryName)) {
          this.filterForm.get('countries')?.setValue([...currentValues, selectedCountryName]);
          this.loadStates();
          const selectedCountry = this.allCountriesSymbol.find((c: any) => c?.countryName === selectedCountryName);
          if (selectedCountry) {
            this.currencySymbol = selectedCountry.currencySymbol;
          }
        }
        this.countryControl.reset();
        break;

      case 'state':
        const selectedStateName = event.option.value.stateName;
        currentValues = this.filterForm.get('states')?.value || [];
        if (!currentValues.includes(selectedStateName)) {
          this.filterForm.get('states')?.setValue([...currentValues, selectedStateName]);
          this.loadCities();
        }
        this.stateControl.reset();
        break;

      case 'city':
        const selectedCityName = event.option.value.cityName;
        currentValues = this.filterForm.get('cities')?.value || [];
        if (!currentValues.includes(selectedCityName)) {
          this.filterForm.get('cities')?.setValue([...currentValues, selectedCityName]);
        }
        this.cityControl.reset();
        break;

      case 'distributor':
        const selectedDistributor = event.option.value;
        currentValues = this.filterForm.get('distributorId')?.value || [];
        if (!currentValues.some((dist: any) => dist.id === selectedDistributor.id)) {
          this.filterForm.get('distributorId')?.setValue([...currentValues, { id: selectedDistributor.id, name: selectedDistributor.name }]);
        }
        this.distributorControl.reset();
        this.loadDistributors('');
        break;

      case 'category':
        const selectedCategory = event.option.value;
        currentValues = this.filterForm.get('categoryId')?.value || [];
        if (!currentValues.some((cat: any) => cat.id=== selectedCategory.id)) {
          this.filterForm.get('categoryId')?.setValue([...currentValues, {id: selectedCategory.id,name: selectedCategory.name }]);
        }
        this.categoryControl.reset();
        this.loadDistributors('');
        break;

      case 'symbol':
        const selectedSymbol = event.option.value; 
          const currency = selectedSymbol.split(' - ')[1];
        currentValues = this.filterForm.get('currency')?.value || [];
        if (!currentValues.some((curr: any) => curr.currency === currency)) {
          const newCurrency = { currency, label: selectedSymbol };
            this.filterForm.get('currency')?.setValue([...currentValues, newCurrency]);
        }
        this.currencySymbolControl.reset();
        break;

      case 'range':
        const selectedRange = event.option.value;
        currentValues = this.filterForm.get('turnOver')?.value || [];
        if (!currentValues.some((range: any) => range.label === selectedRange.label)) {
          this.filterForm.get('turnOver')?.setValue([...currentValues, selectedRange]);
        }
        this.amountRangeControl.reset();
        break;

      default:
        return;
    }
    this.applyFilter();
  }
  displayLabel(option: { label: string; min: number; max: number }): string {
    return option ? option.label : '';
  }
  displaySymbol(option: { symbol: string }): string {
    return option ? option.symbol : '';
  }
}